import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  pickFolderController: [
    'runtimeConstant',
    '$scope',
    '$filter',
    '$rootScope',
    'treeService',
    'treeSendFiles',
    'canSelectRepository',
    'idFolderNotShow',
    'userCrudService',
    'ETreeItemTypes',
    function (
      runtimeConstant,
      $scope,
      $filter,
      $rootScope,
      treeService,
      treeSendFiles,
      canSelectRepository,
      idFolderNotShow,
      userCrudService,
      ETreeItemTypes
    ) {
      'use strict';

      function canSelectFolder(item) {
        var lstItemType = [1];

        if (canSelectRepository) {
          lstItemType.push(0);
        }
        if (lstItemType.indexOf(item.TreeItemType) > -1 && item.HasPermission) {
          $scope.selectedFolder = item;
          return true;
        }
        return false;
      }

      function getItemIcon(item) {
        // icons: repository, folder, doctype, additionalFields
        var icons = [
          'md-repository',
          'md-doc-folder',
          'md-doc-type',
          'md-add-fields',
          'md-loading',
        ];

        // icons: repositorio e pasta desabilitados
        var disabledIcons = [
          'md-repository-disabled',
          'md-folder-disabled',
          'md-doc-type',
          'md-add-fields',
          'md-loading',
        ];

        // icons: quickaccess, shared docs, none, checkuot, none, favoritos
        var quickAcess = [
          'md-alarm',
          'md-share',
          '',
          'md-file-download',
          '',
          'md-grade',
          'md md-local-print-shop',
        ];

        if (item.TreeItemType > 4) {
          //Os icons são de 5 a 10, então remove cinco pra ficar certo o indice do array
          return quickAcess[item.TreeItemType - 5];
        }

        if (item.HasPermission) {
          //Retorna os icones habilitados
          return icons[item.TreeItemType];
        } else {
          return disabledIcons[item.TreeItemType];
        }
      }

      function expandFolder(folder, e) {
        // Evita que o envento click se propague para os filhos. Ex( a.li.ul.span.a =  a -> li -> ul -> span)
        if (e !== null) {
          e.stopPropagation();
        }

        if (folder.isOpen === null) {
          folder.isOpen = true;
        } else {
          folder.isOpen = !folder.isOpen;
        }

        var isAllFolders = function (c) {
          return c.TreeItemType !== ETreeItemTypes.LOADING;
        };

        var notEmpty =
          folder.children !== undefined && folder.children !== null;

        if (
          folder.HasChildren === false ||
          (notEmpty && folder.children.every(isAllFolders))
        ) {
          return;
        }

        if (folder.children === undefined || folder.children === null) {
          folder.children = [];
        }

        var anyFolder = folder.children.some(function (c) {
          return c.TreeItemType === ETreeItemTypes.LOADING;
        });

        if (!anyFolder) {
          folder.children.push(treeService.loadingItem);
        }

        treeService.getChildren(folder).then(
          function (data) {
            data = data.filter(function (f) {
              return f.Id !== $scope.idFolderNotShow;
            });

            folder.children.forEach(function (c) {
              if (!c) {
                folder.children.splice(folder.children.indexOf(c), 1);
              } else {
                var f = folder.children.filter(function (e) {
                  return e.Id === c.Id;
                });
                if (f && f.length > 1) {
                  f.forEach(function (remove) {
                    folder.children.splice(folder.children.indexOf(remove), 1);
                  });
                }
              }
            });
            folder.children.splice(
              folder.children.indexOf(treeService.loadingItem),
              1
            );

            data.forEach(function (d) {
              //remover o item undefined
              if (
                !folder.children.some(function (c) {
                  //se não for campo adicional ou tipo de documento vai remover os itens que tem id duplicado
                  return (
                    c &&
                    c.TreeItemType !== ETreeItemTypes.DOCUMENT_TYPE &&
                    c.TreeItemType !== ETreeItemTypes.ADDITIONAL_FIELD &&
                    c.Id === d.Id
                  );
                })
              ) {
                folder.children.push(d);
              }
            });

            folder.children = $filter('orderBy')(folder.children, [
              '+TreeItemType',
              '+Name',
            ]);
          },
          function () {
            swal.fire({
              title: $filter('translate')('CHILDREN LOAD ERROR'),
              text: $filter('translate')('CHILDREN LOAD ERROR MSG'),
              icon: 'error',
              showCancelButton: true,
              confirmButtonColor: '#DD6B55',
              confirmButtonText: $filter('translate')('RETRY'),
              showLoaderOnConfirm: true,
              preConfirm: function () {
                return new Promise(function (resolve) {
                  $scope.expandFolder(folder, e);
                  resolve();
                });
              },
            });
          }
        );
      }

      function loadFolders() {
        if (treeSendFiles) {
          treeService.getCanSendFolders().then((data) => {
            $scope.folders = data;
          });
        } else {
          treeService.getRepositories(true).then((data) => {
            $scope.folders = data;
          });
        }
      }

      function canSelectDocuSign(item) {
        $scope.idFolderIntegration = item.Id;
      }

      function saveDocuSign() {
        $rootScope.user.idFolderIntegration = $scope.idFolderIntegration;
        userCrudService
          .updateIntegrationFolder($rootScope.user.idFolderIntegration)
          .then(() =>
            swal.fire({
              title: $filter('translate')('SUCCESS'),
              icon: 'success',
              confirmButtonText: $filter('translate')('OK'),
            })
          );
      }

      function run() {
        try {
          $scope.folders = null;
          $scope.idFolderNotShow = idFolderNotShow;
          $scope.idFolderIntegration = null;

          $scope.canSelectFolder = logWrapper(
            canSelectFolder,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getItemIcon = logWrapper(
            getItemIcon,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.expandFolder = logWrapper(
            expandFolder,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadFolders = logWrapper(
            loadFolders,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canSelectDocuSign = logWrapper(
            canSelectDocuSign,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.saveDocuSign = logWrapper(
            saveDocuSign,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
